import { action, makeAutoObservable, observable } from 'mobx'

class DropzoneStore {
  file = null
  uploading = false
  progress = 0
  uploadError = null

  constructor() {
    makeAutoObservable(this, {
      file: observable,
      setFile: action,
      setUploading: action,
      setProgress: action,
      setUploadError: action,
    })
  }

  setFile = value => {
    this.file = value
  }
  setUploading = value => {
    this.uploading = value
  }
  setProgress = value => {
    this.progress = value
  }
  setUploadError = value => {
    this.uploadError = value
  }
}

export default DropzoneStore
